import {ReadGlonas} from "../../../Commands";
import React, {Fragment, useEffect, useState} from "react";
import {ClockStation} from "../../../Targets";
import CommonTextControl from "../CommonTextControl/CommonTextControl";
import {Stack} from "rsuite";
import GpsCoordinatesControl from "../GpsCoordinatesControl/GpsCoordinatesControl";
import {GlonasControlProps, GlonasData} from "./GlonasControl.model";

const GlonasControl = ({executeCommand, clockStationId, onCoordinatesChange}: GlonasControlProps) => {
  const [loading, SetLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [data, setData] = useState<GlonasData | null>(null);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | null = null;
    if (isActive) {
      interval = setInterval(() => {
        const dataClone = structuredClone(data as GlonasData)

        if (dataClone.time.seconds < 59) {
          dataClone.time.seconds = dataClone.time.seconds + 1
        } else {
          dataClone.time.seconds = 0
          if (dataClone.time.minutes < 59) {
            dataClone.time.minutes = dataClone.time.minutes + 1
          } else {
            dataClone.time.minutes = 0
            if (dataClone.time.hours < 23) {
              dataClone.time.hours = dataClone.time.hours + 1
            } else {
              dataClone.time.hours = 0
            }
          }
        }

        dataClone.timeParsed = `${dataClone.time.hours < 10 ? `0${dataClone.time.hours}` : dataClone.time.hours}`
          + `:${dataClone.time.minutes < 10 ? `0${dataClone.time.minutes}` : dataClone.time.minutes}`
          + `:${dataClone.time.seconds < 10 ? `0${dataClone.time.seconds}` : dataClone.time.seconds}`
        setData(dataClone)
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isActive, data?.time]);

  useEffect(() => {
    readParameters().then()
  } , [clockStationId])

  useEffect(() => {
    if (!data?.isConnected) {
      onCoordinatesChange?.(null);
      return;
    }

    const coordinates = `${data.latitudeDirection} ${data.latitude} ${data.longitudeDirection} ${data.longitude}`;
    onCoordinatesChange?.(coordinates);
  }, [data, onCoordinatesChange]);

  const readParameters = async () => {

    SetLoading(true)
    setIsActive(false)

    if (typeof executeCommand !== "function") {
      SetLoading(false)
      return;
    }

    try {
      const result = await executeCommand(ClockStation, ReadGlonas, [])

      const utf8decoder = new TextDecoder()
      let buffer = new Uint8Array(result.Params as ArrayBuffer);

      //1. Один байт: признак данных. ‘A’ – данные актуальны, ‘V’ – данные на актуальны, символ ‘N’ – нет данных с приёмника (не подключен или вышел из строя).
      //2. Один байт направления широты: ‘N’-север / ‘S’-юг.
      //3. Шесть байт широты в формате "ГГММмм": ГГ – градусы, ММ – минуты, мм – сотые доли минуты.
      //4. Один байт направления долготы: 'E'-восток / 'W'-запад.
      //5. Семь байт долготы в формате "ГГГММмм": ГГГ – градусы, ММ – минуты, мм – сотые доли минуты.
      //6. Шесть байт время UTC в формате "ЧЧММСС": ЧЧ – часы, ММ – минуты, СС – секунды

      const text = utf8decoder.decode(buffer);
      const newGpsData: GlonasData = {
        isConnected: text[0] !== "N",
        isActual: text[0] === "A",
        latitudeDirection: (text[1] as "N" | "S"),
        latitude: text.slice(2, 8),
        longitudeDirection: (text[8] as "E" | "W"),
        longitude: text.slice(9, 16),
        time: {
          hours: Number(text.slice(16, 18)),
          minutes: Number(text.slice(18, 20)),
          seconds: Number(text.slice(20, 22))
        },
        timeParsed: `${text.slice(16, 18)}:${text.slice(18, 20)}:${text.slice(20, 22)}`
      };

      if (newGpsData.isConnected && newGpsData.isActual) {
        setIsActive(true)
      }

      setData(newGpsData)
      setInitialized(true)

      return text;
    } finally {
      SetLoading(false)
    }
  }
  const spin = loading
    ? <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    : null;

  const renderData = () => {

    if (data === null)
      return

    if (!data.isConnected)
      return <p>Нет данных с приемника</p>;

    return (
      <div className={"row"}>
        {
          data?.isActual
            ? <p>Данные актуальны</p>
            : <p>Данные не актуальны</p>
        }
        <GpsCoordinatesControl longitudeDirection={data.longitudeDirection}
                               longitude={data.longitude}
                               latitudeDirection={data.latitudeDirection}
                               latitude={data.latitude}
        />
        <Stack className={"pt-2"}>
          <CommonTextControl label={"Время по Гринвичу"}
                             initialValue={data.timeParsed}
          />
        </Stack>
      </div>
    )
  }

  return (
    <>{ renderData() }</>
  )
}

export default GlonasControl;
